import React from "react"

import CookieConsent from "./CookieConsent"
import FloatingCTA from "./FloatingCTA"

export default function RootLayout({ children }) {
  return (
    <>
      {children}
      <FloatingCTA />
      <CookieConsent />
    </>
  )
}
